import { LegacyEpisodePlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { getEpisodeTvSeries } from './get-episode-tv-series';

export function getTvSeriesWatchParams(
    episode: LegacyEpisodePlayerBaseInfoContent | undefined | null
) {
    const tvSeries = episode && getEpisodeTvSeries(episode);

    return tvSeries?.ott?.userData?.watchParams || undefined;
}
